import { render, staticRenderFns } from "./OverlayAdditionalProducts.vue?vue&type=template&id=3b87a082&"
import script from "./OverlayAdditionalProducts.vue?vue&type=script&lang=js&"
export * from "./OverlayAdditionalProducts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/guave/fwgcontao/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3b87a082')) {
      api.createRecord('3b87a082', component.options)
    } else {
      api.reload('3b87a082', component.options)
    }
    module.hot.accept("./OverlayAdditionalProducts.vue?vue&type=template&id=3b87a082&", function () {
      api.rerender('3b87a082', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "frontend/fwgcontao/js/pages/OverlayAdditionalProducts.vue"
export default component.exports